export function List(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.66671 2.33268C3.66671 1.41221 2.92052 0.666016 2.00004 0.666016C1.07957 0.666016 0.333374 1.41221 0.333374 2.33268C0.333374 3.25316 1.07957 3.99935 2.00004 3.99935C2.92052 3.99935 3.66671 3.25316 3.66671 2.33268Z"
          fill="currentColor"
        />
        <path
          d="M5.80004 1.53268C5.35821 1.53268 5.00004 1.89085 5.00004 2.33268C5.00004 2.77451 5.35821 3.13268 5.80004 3.13268H12.8667C13.3085 3.13268 13.6667 2.77451 13.6667 2.33268C13.6667 1.89085 13.3085 1.53268 12.8667 1.53268H5.80004Z"
          fill="currentColor"
        />
        <path
          d="M5.80004 6.19935C5.35821 6.19935 5.00004 6.55752 5.00004 6.99935C5.00004 7.44118 5.35821 7.79935 5.80004 7.79935H12.8667C13.3085 7.79935 13.6667 7.44118 13.6667 6.99935C13.6667 6.55752 13.3085 6.19935 12.8667 6.19935H5.80004Z"
          fill="currentColor"
        />
        <path
          d="M5.80004 10.866C5.35821 10.866 5.00004 11.2242 5.00004 11.666C5.00004 12.1078 5.35821 12.466 5.80004 12.466H12.8667C13.3085 12.466 13.6667 12.1078 13.6667 11.666C13.6667 11.2242 13.3085 10.866 12.8667 10.866H5.80004Z"
          fill="currentColor"
        />
        <path
          d="M2.00004 5.33268C2.92052 5.33268 3.66671 6.07887 3.66671 6.99935C3.66671 7.91982 2.92052 8.66602 2.00004 8.66602C1.07957 8.66602 0.333374 7.91982 0.333374 6.99935C0.333374 6.07887 1.07957 5.33268 2.00004 5.33268Z"
          fill="currentColor"
        />
        <path
          d="M3.66671 11.666C3.66671 10.7455 2.92052 9.99935 2.00004 9.99935C1.07957 9.99935 0.333374 10.7455 0.333374 11.666C0.333374 12.5865 1.07957 13.3327 2.00004 13.3327C2.92052 13.3327 3.66671 12.5865 3.66671 11.666Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
